CT.flCodeToNameMapping = $.extend({
	"SG" : "Spicjet",
	"6E" : "Indigo",
	"G8" : "GoAir",
	"IX" : "Air India Express",
	"IT" : "Kingfisher",
	"9W" : "Jet Airways",
	"S2" : "JetKonnect",
	"AI" : "Air India",
	"M1" : "Air Mantra",
	"V1" : "Ventura Air Connect",
	"9W-K" : "JetKonnect",
	"IT-RED" : "Kingfisher Red"
}, CT.settings || {})
;
